export default "__VITE_ASSET__n859R_ph__"